import { DashboardPeriodPreset, IVisitPeriod } from "../types/ownerDashboard.types";
import { getAllTimePeriod } from "./getAllTimePeriod";

function formatVisitDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

export function getChartMonthsRange(
  months: number,
  referenceDate = new Date()
): IVisitPeriod {
  const end = new Date(referenceDate);
  const start = new Date(referenceDate);
  start.setMonth(start.getMonth() - months);

  return {
    initial_date: formatVisitDate(start),
    final_date: formatVisitDate(end),
  };
}

export function getDashboardChartPeriodRange(
  preset: DashboardPeriodPreset,
  referenceDate = new Date(),
  historyYears?: number
): IVisitPeriod {
  switch (preset) {
    case "last_30_days": {
      const start = new Date(referenceDate);
      start.setDate(start.getDate() - 30);
      return {
        initial_date: formatVisitDate(start),
        final_date: formatVisitDate(referenceDate),
      };
    }
    case "last_90_days": {
      const start = new Date(referenceDate);
      start.setDate(start.getDate() - 90);
      return {
        initial_date: formatVisitDate(start),
        final_date: formatVisitDate(referenceDate),
      };
    }
    case "last_6_months":
      return getChartMonthsRange(6, referenceDate);
    case "last_12_months":
      return getChartMonthsRange(12, referenceDate);
    case "current_year":
      return {
        initial_date: `01/01/${referenceDate.getFullYear()}`,
        final_date: formatVisitDate(referenceDate),
      };
    case "all_time":
      return getAllTimePeriod(referenceDate, historyYears);
    default:
      return getChartMonthsRange(12, referenceDate);
  }
}
